import { render, staticRenderFns } from "./SvgSponsor.vue?vue&type=template&id=90a6aba4&"
import script from "./SvgSponsor.vue?vue&type=script&lang=js&"
export * from "./SvgSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports